// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CarouselArrow__arrow___2RpvE{display:flex;align-items:center;justify-content:center;width:24px;height:24px;border:none;border-radius:50%;background-color:#1b31a4;cursor:pointer}.CarouselArrow__big___1fpSR{width:40px;height:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"arrow": "CarouselArrow__arrow___2RpvE",
	"big": "CarouselArrow__big___1fpSR"
};
module.exports = ___CSS_LOADER_EXPORT___;
